import React, { Component } from 'react'

export default class ShareLink extends Component {


    closeFx = () => {

        this.props.closeMe()
    }

    copyFx = () => {

        const copyText = document.getElementById('copyTxt')
        copyText.select()
        copyText.setSelectionRange(0, 99999)
        document.execCommand('copy')
    }

    render() {

        const copyText = 'https://submem.com/download/' + this.props.fileName

		return (

            <div className= 'NightWrapper'>

                <div id='shareUrlBox'>

                    <input id='copyTxt' type='text' value={copyText} />
                    <span className='RegBtn' onClick={this.copyFx}>Copy</span>
                    <span className='RegBtn' onClick={this.closeFx}>Close</span>
                </div>

            </div>

		)
	}
}





// WEBPACK FOOTER //
// ./src/components/share/ShareLink.js